import { useSelector } from 'hooks/utils';
import { selectActiveAnalysisIds } from 'store/data/analyses';

export function useAnalyses() {
	return useSelector(state => selectActiveAnalysisIds(state.data.analyses));
}
